import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

const initialState = {
  id: null,
  roles: [],
  firstname: "",
  lastname: "",
  img: "",
  isActif: false,
  visible: false,
  contact: "",
  createdAt: "",
  username: "",
  updatedAt: "",
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuth: (state, { payload }) => {
      state.id = payload.id;
      state.roles = payload.roles;
      state.firstname = payload.firstname;
      state.lastname = payload.lastname;
      state.img = payload.img;
      state.isActif = payload.isActif;
      state.visible = payload.visible;
      state.contact = payload.contact;
      state.username = payload.username;
      state.createdAt = payload.createdAt;
      state.updatedAt = payload.updatedAt;
    },
    logOut: (state) => {
      state.id = null;
      state.roles = [];
      state.firstname = "";
      state.lastname = "";
      state.img = "";
      state.isActif = false;
      state.visible = false;
      state.contact = "";
      state.username = "";
      state.createdAt = "";
      state.updatedAt = "";
      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");
      toast.success("Vous ètes déconnecté.");
    },
  },
});

export const { setAuth, logOut } = authSlice.actions;

export default authSlice.reducer;
